webpackJsonp([35],{

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Sidebar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _vivalid = __webpack_require__(236);

var _vivalid2 = _interopRequireDefault(_vivalid);

var _utils = __webpack_require__(77);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// CONSTANTS are all caps.
var NS = 'Sidebar';
var CLS = 'sidebar';
var WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/sidebar.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

// import form validation library

var Sidebar = exports.Sidebar = function () {
	function Sidebar($el) {
		_classCallCheck(this, Sidebar);

		// $el is the widget node return by the loadSidebar function
		this.$el = $el;
	}

	_createClass(Sidebar, [{
		key: 'init',
		value: function init() {
			this.setSidebar();
		}
	}, {
		key: 'setSidebar',
		value: function setSidebar() {
			// Add Some logic here
			var $wg = $(this.$el);
			var sidebarCloseBtn = $wg.find('.sidebar-toggle.is-close');

			sidebarCloseBtn.hide();
			$wg.find('.sidebar-toggle:not(.no-tab)').on('click', function (e) {
				var This = $(this);
				var tab = This.next('.sidebar-tabContent');

				if (utils.isOnMobile()) {
					$('.sidebar-tabContent').not(tab).slideUp(0).removeClass('active');
					if (This.is('.active')) {
						tab.slideUp(300).removeClass('active');
						This.removeClass('active');
					} else {
						tab.slideDown(300).addClass('active');
						This.toggleClass('active');
					}
				} else {
					if (This.is('.active')) {
						This.find('span').unbind('mouseenter mouseleave');
						hideSidebar(This);
						return false;
					} else {
						$('.sidebar-tabContent').not(tab).fadeOut(0).removeClass('active');
						tab.fadeIn(300).addClass('active');
						This.not('.is-close').addClass('active');
					}
				}

				$('.sidebar-toggle').not(This).removeClass('active');

				var activeTabs = $wg.find('.sidebar-toggle.active').length;

				if (!utils.isOnMobile()) {
					if ($wg.hasClass('is-expanded') && activeTabs === 0 || This.is('.is-close')) {
						hideSidebar(This);
					} else {
						showSidebar(This);
					}
				}

				function hideSidebar($btn) {
					$wg.animate({ right: '-390px' }, 300, function () {
						$wg.removeClass('is-expanded');
						sidebarCloseBtn.hide();
						if ($btn.is('.active, .is-close')) {
							$wg.find('.sidebar-toggle, .sidebar-tabContent').removeClass('active');
						}
					});
				}

				function showSidebar($btn) {
					$wg.animate({ right: '0' }, 500, function () {
						$wg.addClass('is-expanded');
						sidebarCloseBtn.show();
					});
				}
			});

			var $promoCode = $wg.find('#promoCode');
			var $promoCodeField = $wg.find('.promo-code');
			var $resetBtn = $wg.find('#resetBtnSidebar');

			$promoCode.on('change', function () {
				$resetBtn.trigger('click');
				if ($(this).is(':checked')) {
					$promoCodeField.fadeIn(0);
				} else {
					$promoCodeField.fadeOut(0);
				}
			});

			// call the rules
			// sidebar contains 1 form(s) only
			// if ($(document).find('form').length <= 1) {
			// 	utils.formValidationRules();
			// }

			// let addCallback = vivalid.htmlInterface.addCallback;
			// let initAllValidations = vivalid.htmlInterface.initAll;

			// addCallback('onValidationSuccessSidebar', function() {
			//     let $form = $wg.find('form');
			// 	// submit, if this is an ajax call, replace with an ajax call
			// 	$form.submit();
			// });

			// addCallback('onValidationFailureSidebar', function(invalid, pending, valid) {
			// 	// invalid ...
			// 	// no submission goes through
			// });

			// sidebar contains 2 forms only
			// if ($(document).find('form').length <= 2) {
			// 	initAllValidations();
			// }

			// this code closes the sidebar if user clicks outside it, it causes issues with minicart
			// it causes issues once clicking on the popup confirmation to remove the items from the minicart
			// $(document).mouseup(function(e) {
			// 	// if the target of the click isn't the container nor a descendant of the container
			// 	if (!utils.isOnMobile()) {
			// 		if (!$wg.is(e.target) && $wg.has(e.target).length === 0) {
			// 			// find current active tab
			// 			let This = $wg.find('.sidebar-toggle.active');
			// 			$wg.animate({right: '-390px'}, 300, function() {
			// 				$wg.removeClass('is-expanded');
			// 				sidebarCloseBtn.hide();
			// 				$(This.attr('href')).toggleClass('active');
			// 				This.toggleClass('active');
			// 				$('.sidebar-tabContent').fadeOut(0).removeClass('active');
			// 			});
			// 		}
			// 	}
			// });
		}

		// Add more functions like on above here

	}]);

	return Sidebar;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ })

});


// WEBPACK FOOTER //
// wg-sidebar-chunk.js